// src/components/VantaBirdsBackground.tsx
import React, { useEffect, useRef, useState } from "react";

declare global {
    interface Window {
        THREE: any;
        VANTA: any;
    }
}

const loadScript = (src: string): Promise<void> => {
    return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
            resolve(); // Already loaded
            return;
        }

        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Failed to load ${src}`));
        document.body.appendChild(script);
    });
};

const VantaBirdsBackground: React.FC = () => {
    const vantaRef = useRef<HTMLDivElement | null>(null);
    const [vantaEffect, setVantaEffect] = useState<any>(null);

    useEffect(() => {
        const initVanta = async () => {
            try {
                await loadScript("https://cdnjs.cloudflare.com/ajax/libs/three.js/r134/three.min.js");
                await loadScript("https://cdn.jsdelivr.net/npm/vanta@latest/dist/vanta.birds.min.js");

                if (!vantaEffect && vantaRef.current && window.VANTA?.BIRDS && window.THREE) {
                    setVantaEffect(
                        window.VANTA.BIRDS({
                            el: vantaRef.current,
                            mouseControls: true,
                            touchControls: true,
                            gyroControls: false,
                            minHeight: 200.0,
                            minWidth: 200.0,
                            scale: 1.0,
                            scaleMobile: 1.0,
                            backgroundColor: 0x0,
                            color1: 0x1313ed,
                            color2: 0x1313ed,
                            birdSize: 1.5,
                            wingSpan: 30,
                            speedLimit: 5,
                            separation: 20,
                            alignment: 20,
                            cohesion: 20,
                        })
                    );
                }
            } catch (err) {
                console.error("Vanta init error:", err);
            }
        };

        initVanta();

        return () => {
            if (vantaEffect) vantaEffect.destroy();
        };
    }, [vantaEffect]);

    return (
        <div
            ref={vantaRef}
            className="vanta-bg"
            aria-hidden="true"

        />
    );

};

export default VantaBirdsBackground;
